import salePaths from './pages/performance/sale-paths'
import routes from './routes'
import sidebar from './sidebar'

const resources = {
  sidebar,
  routes,
  pages: {
    performance: {
      salePaths,
    },
  },
}

export type LocalizationEN = typeof resources

export default resources
